import { combineReducers } from 'redux';

import hadCompleteResponse, * as fromHadCompleteResponse from './hadCompleteResponse';
import { createHadErrorFPSMutationToBookingReducer } from './hadErrorFPSMutationToBooking';
import * as fromHadErrorFPSMutationToBooking from './hadErrorFPSMutationToBooking';
import hadItineraries, * as fromHadItineraries from './hadItineraries';
import hadSuccessfulBookingMutation, * as fromHadSuccessfulBookingMutation from './hadSuccessfulBookingMutation';
import lastFlightsItinerariesRendered, * as fromLastFlightsItinerariesRendered from './lastFlightsItinerariesRendered';

import type { GetExitingItineraryId } from '../flightBookingPanel/entities/flights';
import type { FpsState } from '@web-platform/shared-universal-types/src/redux/banana/state/shared/fps';
import type { ItineraryID } from '@web-platform/shared-universal-types-utils/src/utils';

export const createFpsReducer = (getExitingId: GetExitingItineraryId) =>
  combineReducers({
    hadItineraries,
    hadCompleteResponse,
    hadSuccessfulBookingMutation,
    hadErrorFPSMutationToBooking: createHadErrorFPSMutationToBookingReducer(getExitingId),
    lastFlightsItinerariesRendered,
  });

export const getHadCompleteResponse = (state: FpsState): boolean =>
  fromHadCompleteResponse.get(state.hadCompleteResponse);

export const getHadItineraries = (state: FpsState): boolean =>
  fromHadItineraries.get(state.hadItineraries);

export const getLastFlightsItinerariesRendered = (state: FpsState): boolean =>
  fromLastFlightsItinerariesRendered.get(state.lastFlightsItinerariesRendered);

export const getHadSuccessfulBookingMutation = (
  state: FpsState,
  itineraryId: ItineraryID,
): boolean => fromHadSuccessfulBookingMutation.get(state.hadSuccessfulBookingMutation)[itineraryId];

export const getHadErrorFPSMutationToBooking = (
  state: FpsState,
  itineraryId: ItineraryID,
): boolean => fromHadErrorFPSMutationToBooking.get(state.hadErrorFPSMutationToBooking)[itineraryId];
